<template>
    <v-dialog
        v-model="dialog"
        :fullscreen="fullscreen"
        :max-width="maxWidth"
        :transition="transition"
        :overlay="!fullscreen"
        scrollable
    >
        <v-btn
            slot="activator"
            dark
            fab
            :color="mode.color"
            :icon="tableAction"
            :small="tableAction"
            :falt="!tableAction"
            :fixed="!tableAction"
            :right="tableAction ? false : 'right'"
            :class="tableAction ? '' : 'despesa-fab'"
        ><v-icon>{{ mode.icon }}</v-icon></v-btn>
        <v-card>
            <v-toolbar card dark color="primary">
                <v-btn icon @click.native="toggleDialog" dark>
                    <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>{{ mode.action }} Despesa</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark flat @click.native="save" :disabled="$v.$invalid || saving" :loading="saving">Salvar</v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
                <v-list three-line>
                    <v-container grid-list-lg>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-autocomplete
                                    label="Categoria"
                                    append-icon="category"
                                    :items="categorias"
                                    v-model="objDespesa.categoria"
                                    required
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12>
                                <v-menu
                                    v-model="dtDespesaDP"
                                    locale="pt-br"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            v-model="computedDateFormatted"
                                            label="Data da Despesa"
                                            append-icon="event"
                                            readonly
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker locale="pt-br" v-model="objDespesa.dt_despesa" @input="dtDespesaDP = false" required></v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field type="number" prefix="R$" append-icon="attach_money" label="Valor" v-model="objDespesa.valor" required></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-textarea
                                    name="obs"
                                    label="Observação"
                                    v-model="objDespesa.obs"
                                ></v-textarea>
                            </v-flex>
                            <v-flex xs12 v-if="!isEditing">
                                <UploadButton outline block
                                    name="objDespesa.img_nf.base64"
                                    ref="imgUploadBtn"
                                    color="grey"
                                    title="Adicione a Nota Fiscal"
                                    accept="image/*"
                                    @file-update="fileUpdate"
                                    :required="isImgNfRequired"
                                >
                                    <template slot="icon">
                                        <v-icon right>add_a_photo</v-icon>
                                    </template>
                                </UploadButton>
                            </v-flex>
                            <v-flex xs12 v-if="objDespesa.img_nf.base64">
                                <v-layout justify-center align-content-center>
                                    <img height="200" :src="objDespesa.img_nf.base64" alt="Nota Fiscal">
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-list>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState             } from 'vuex';
import { validationMixin      } from 'vuelidate';
import { required, requiredIf } from 'vuelidate/lib/validators';
import Util                     from '@/util';
import modalMixin               from '@/mixins/modalMixin';
import momentMixin              from '@/mixins/momentMixin';
import UploadButton             from 'vuetify-upload-button';
import PouchDB                  from 'pouchdb-browser';

let despesasDB = new PouchDB('despesas');

const objDespesaDefault = {
    categoria  : null,
    dt_despesa : null,
    valor      : null,
    obs        : null,
    img_nf     : {
        nome   : null,
        ext    : null,
        base64 : null
    }
}

export default {
    name       : 'DespesasModal',
    mixins     : [modalMixin, momentMixin, validationMixin],
    components : {
        UploadButton
    },
    validations() {
        if (this.isImgNfRequired) {
            return {
                objDespesa : {
                    categoria  : {
                        required
                    },
                    dt_despesa : {
                        required
                    },
                    valor      : {
                        required
                    },
                    img_nf     : {
                        base64 : {
                            required
                        }
                    }
                }
            }
        } else {
            return {
                objDespesa : {
                    categoria  : {
                        required
                    },
                    dt_despesa : {
                        required
                    },
                    valor      : {
                        required
                    }
                }
            }
        }
    },
    props      : {
        relatorio   : {
            type    : String
        },
        despesa     : {
            type    : Object,
            default : function () {
                return objDespesaDefault
            },
        },
        tableAction : {
            type    : Boolean,
            default : false
        },
        reloadGrid  : Function
    },
    methods    : {
        setObjDespesa() {
            if (this.despesa._id) {
                this.objDespesa  = JSON.parse(JSON.stringify(this.despesa));
                this.positivo    = this.objDespesa.categoria.positivo || undefined;
                this.objDespesa.categoria = this.objDespesa.categoria._id ? this.objDespesa.categoria._id : this.objDespesa.categoria;
            } else {
                this.resetObjDespesa();
            }
        },
        resetObjDespesa() {
            this.objDespesa            = JSON.parse(JSON.stringify(objDespesaDefault));
            this.objDespesa.dt_despesa = this.formatDateUTC(new Date(), 'YYYY-MM-DD');
        },
        getCategorias() {
            this.loading = true;
            const filter = `?filter={"ativa":true${this.isAdmin ? '' : ',"positivo":true'}}`;
            if (this.isOnline) {
                this.$axios.get(`categorias${filter}`).then(response => {
                    this.sinais = {};
                    this.categorias = response.data.items.map(categoria => {
                        return { ...categoria, value: categoria._id, text: categoria.nome}
                    });
                    this.$offlineStorage.set('categorias', this.categorias);
                }, error => {
                    console.error('getCategorias() -> Erro inexperado:', error);
                }).then(() => {
                    this.loading = false;
                });
            } else {
                this.categorias = this.$offlineStorage.get('categorias');
                this.loading = false;
            }
        },
        fileUpdate (file) {
            if (typeof file !== 'undefined') {
                // console.log('fileUpdate:', file);
                const fr = new FileReader();
                fr.readAsDataURL(file);
                fr.addEventListener("load", () => {
                    this.objDespesa.img_nf.base64 = fr.result;
                    // this.objDespesa.img_nf = file;
                    // this.imageFile         = file;
                });
            }
        },
        onlineSave(objDespesa) {
            const id = (objDespesa._id ? `/${this.objDespesa._id}` : '');
            this.$axios[this.mode.method](`despesas${id}`, objDespesa).then(response => {
                this.toggleDialog();
                window.getApp.snackbar = {
                    show  : true,
                    color : 'green',
                    text  : this.mode.snack
                };
                setTimeout(this.reloadGrid(), 3000);
                // this.resetObjDespesa();
            }).catch(error => {
                // this.toggleDialog();
                const errorMsg = Util.getErrorMsg(error.response && error.response.data ? error.response.data : error);
                console.error(errorMsg.detailedMsg);
                setTimeout(this.reloadGrid(), 3000);
                window.getApp.snackbar = {
                    show  : true,
                    color : 'red',
                    text  : errorMsg.msg
                };
            }).finally(() => {
                this.saving = false;
                this.reloadGrid();
            });
        },
        offlineSave(objDespesa) {
            if (!objDespesa._id) {
                // Registra ID único p/ o PouchDB
                objDespesa._id = `unsync-${Math.round((new Date()).getTime())}`;
            }
            objDespesa.unsync = true;
            despesasDB.put(objDespesa, function callback(err, result) {
                if (err) {
                    console.error('Ocorreu um erro ao registrar despesa:', err);
                } else {
                    console.log('Despesa registrada localmente com sucesso!', objDespesa);
                }
            });
            window.getApp.snackbar = {
                show  : true,
                color : 'green',
                text  : `${this.mode.snack} (offline)`
            };
            this.saving = false;
            this.reloadGrid();
            this.toggleDialog();
        },
        save() {
            this.saving = true;
            let objDespesa = {}

            if (this.isEditing) {
                objDespesa = {
                    _id        : this.objDespesa._id,
                    relatorio  : this.relatorio,
                    categoria  : this.objDespesa.categoria,
                    dt_despesa : this.formatDateISO(this.objDespesa.dt_despesa),
                    valor      : this.objDespesa.valor,
                    obs        : this.objDespesa.obs
                }
            } else {
                objDespesa = {
                    _id        : this.objDespesa._id,
                    relatorio  : this.relatorio,
                    categoria  : this.objDespesa.categoria,
                    dt_despesa : this.formatDateISO(this.objDespesa.dt_despesa),
                    valor      : this.objDespesa.valor,
                    obs        : this.objDespesa.obs,
                    status     : 'Aguardando validação',
                    img_nf     : this.objDespesa.img_nf
                }
            }
            if (this.objDespesa._rev) {
                objDespesa._rev = this.objDespesa._rev;
            }

            if (this.isOnline && !this.objDespesa.unsync) {
                this.onlineSave(objDespesa);
            } else {
                objDespesa.img_nf = this.objDespesa.img_nf;
                this.offlineSave(objDespesa);
            }
        }
    },
    computed   : {
        ...mapState(['user']),
        isAdmin() {
            return this.user.perfis.some(perfil => perfil === 'Administrador');
        },
        id() {
            return this.objDespesa._id;
        },
        isImgNfRequired () {
            if (this.isEditing) {
                return false;
            } else if (this.objDespesa.categoria){
                const [categoria] = this.categorias.filter(cat => cat._id == this.objDespesa.categoria);
                return categoria.positivo || true;
            } else {
                return true;
            }
        },
        computedDateFormatted () {
            return this.formatDateUTC(this.objDespesa.dt_despesa);
        }
    },
    mounted() {
        this.setObjDespesa();
    },
    watch      : {
        dialog(novo, antigo) {
            if (novo) {
                this.getCategorias();
                this.setObjDespesa();
                if (!this.isEditing){
                    this.$refs.imgUploadBtn.clear();
                }
            }
        }
    },
    data() {
        return {
            dtDespesaDP : false,
            objDespesa  : JSON.parse(JSON.stringify(objDespesaDefault)),
            categorias  : []
        };
    }
};
</script>

<style lang="stylus" scoped>
    .despesa-fab
        bottom        : 10% !important;
        right         : 3;
        border-radius : 5;
</style>
